<div class="attr-backdrop" (click)="onClose()"></div>

<div class="attr-sheet" role="dialog" aria-modal="true">
  <button type="button" class="attr-close" (click)="onClose()" [attr.aria-label]="'attractions.close' | translate">
    <app-attr-icon name="close" [size]="18"></app-attr-icon>
  </button>

  <app-attraction-error-state *ngIf="error && !detail" class="attr-sheet-state"
    [message]="error" (retry)="retry()">
  </app-attraction-error-state>

  <div class="attr-sheet-state attr-loading" *ngIf="loading && !detail">
    <div class="attr-spinner"></div>
  </div>

  <div class="attr-scroll" *ngIf="detail as product">
    <!-- Hero gallery -->
    <div class="attr-gallery">
      <swiper-container *ngIf="galleryImages.length > 1" class="attr-gallery-swiper"
        pagination="true" pagination-dynamic-bullets="true" pagination-dynamic-main-bullets="5"
        pagination-clickable="true">
        <swiper-slide *ngFor="let img of galleryImages">
          <app-attraction-image class="attr-gallery-img" [url]="img" [alt]="product.title || ''"></app-attraction-image>
        </swiper-slide>
      </swiper-container>
      <app-attraction-image *ngIf="galleryImages.length <= 1" class="attr-gallery-img single"
        [url]="galleryImages.length ? galleryImages[0] : null" [alt]="product.title || ''">
      </app-attraction-image>

      <div class="attr-photo-pill" *ngIf="galleryImages.length > 1">
        <app-attr-icon name="photo" [size]="14"></app-attr-icon>
        <span>{{ galleryImages.length }}</span>
      </div>
    </div>

    <!-- Title + rating -->
    <div class="attr-section-pad attr-title-block">
      <h2 class="attr-detail-title">{{ product.title }}</h2>
      <app-attraction-rating-row [rating]="product.rating" [reviewCount]="product.review_count"></app-attraction-rating-row>
    </div>

    <!-- Description -->
    <p class="attr-description" *ngIf="product.description">{{ product.description }}</p>

    <!-- Fact rows -->
    <div class="attr-facts">
      <app-attraction-fact-row *ngIf="hasFlag(FLAG_FREE_CANCELLATION)"
        icon="calendar"
        [title]="'attractions.freeCancellation' | translate"
        [subtitle]="product.cancellation_policy?.description || null">
      </app-attraction-fact-row>

      <app-attraction-fact-row *ngIf="hasFlag(FLAG_LIKELY_TO_SELL_OUT)"
        icon="fire" [highlightIcon]="true"
        [title]="'attractions.likelySellOut' | translate"
        [subtitle]="'attractions.likelySellOutDesc' | translate">
      </app-attraction-fact-row>

      <app-attraction-fact-row *ngIf="durationText"
        icon="schedule"
        [title]="durationText"
        [subtitle]="'attractions.durationCheck' | translate">
      </app-attraction-fact-row>

      <app-attraction-fact-row *ngIf="languagesText"
        icon="translate"
        [title]="'attractions.languagesOffered' | translate"
        [subtitle]="languagesText">
      </app-attraction-fact-row>

      <app-attraction-fact-row *ngIf="pickupText"
        icon="bus"
        [title]="'attractions.pickup' | translate"
        [subtitle]="pickupText">
      </app-attraction-fact-row>

      <app-attraction-fact-row *ngIf="goodToKnowText"
        icon="info"
        [title]="'attractions.goodToKnow' | translate"
        [subtitle]="goodToKnowText">
      </app-attraction-fact-row>
    </div>

    <!-- Ratings breakdown -->
    <ng-container *ngIf="showRatingsBreakdown">
      <h3 class="attr-section-header">{{ 'attractions.ratingsBreakdown' | translate }}</h3>
      <div class="attr-section-pad">
        <app-attraction-rating-breakdown
          [rating]="product.rating"
          [reviewCount]="product.review_count"
          [histogram]="product.rating_histogram"
          [sources]="product.review_sources">
        </app-attraction-rating-breakdown>
      </div>
    </ng-container>

    <!-- Inclusions -->
    <ng-container *ngIf="inclusions.length">
      <h3 class="attr-section-header">{{ 'attractions.inclusions' | translate }}</h3>
      <div class="attr-bullet" *ngFor="let item of inclusions">
        <app-attr-icon name="check" [size]="18" class="attr-bullet-icon include"></app-attr-icon>
        <span>{{ item }}</span>
      </div>
    </ng-container>

    <!-- Exclusions -->
    <ng-container *ngIf="exclusions.length">
      <h3 class="attr-section-header">{{ 'attractions.exclusions' | translate }}</h3>
      <div class="attr-bullet" *ngFor="let item of exclusions">
        <app-attr-icon name="close" [size]="18" class="attr-bullet-icon exclude"></app-attr-icon>
        <span>{{ item }}</span>
      </div>
    </ng-container>

    <!-- Cancellation policy -->
    <ng-container *ngIf="cancellationText">
      <h3 class="attr-section-header">{{ 'attractions.cancellationPolicy' | translate }}</h3>
      <p class="attr-text-section">{{ cancellationText }}</p>
    </ng-container>

    <!-- Meeting point -->
    <ng-container *ngIf="meetingPointText">
      <h3 class="attr-section-header">{{ 'attractions.meetingPoint' | translate }}</h3>
      <p class="attr-text-section">{{ meetingPointText }}</p>
    </ng-container>
  </div>

  <!-- Sticky book bar -->
  <div class="attr-book-bar" *ngIf="detail">
    <div class="attr-book-price">
      <div class="attr-book-was" *ngIf="beforePrice">{{ 'attractions.fromPrice' | translate:{ price: beforePrice } }}</div>
      <div class="attr-book-now" *ngIf="price">
        <span class="attr-book-from">{{ 'attractions.fromPrice' | translate:{ price: price } }}</span>
        <span class="attr-book-per">{{ 'attractions.perPerson' | translate }}</span>
      </div>
    </div>
    <button type="button" class="attr-book-btn" (click)="onBook()">{{ 'attractions.bookNow' | translate }}</button>
  </div>
</div>
